




import stripe from '@/store/modules/stripe';
import { Component, Vue } from 'vue-property-decorator';

@Component({})
export default class StripeStep extends Vue {
    private async mounted() {
        const stripePaymentElement = await stripe.getStripePaymentElement();

        if (stripePaymentElement) {
            stripePaymentElement.on('change', (event) => {
                // Set selected method code to save it in order
                if (event.value && event.value.type) {
                    stripe.setSelectedMethodCode(event.value.type);
                }
            });

            if (this.$refs.stripePayments) {
                stripePaymentElement.mount(this.$refs.stripePayments as HTMLElement);
            }
        }
    }
}
